<template>
    <view class="cart-container">
        <!-- 有商品时的列表 -->
        <view class="scroll-content" v-if="cartList.length > 0">
            <view class="cart-list">
                <view class="cart-card" v-for="(item, index) in cartList" :key="item.uuid" @touchstart="startPress"
                    @touchend="cancelPress" @touchmove="cancelPress">
                    <view class="checkbox-area" @click="toggleCheck(index)">
                        <img class="check-img"
                            :src="item.checked ? comapi.getImageUrl('/wxmini/icon/icon25_1.png') : comapi.getImageUrl('/wxmini/icon/icon25.png')"
                            mode="aspectFit" />
                    </view>
                    <img :src="comapi.getImageUrl(item.cover_image)" class="prod-img" mode="aspectFill" />
                    <view class="prod-info">
                        <view class="prod-title-spec">
                            <text class="prod-title">{{ item.product_name + '（' + item.spec_name + '）' }}</text>
                            <text class="prod-spec">规格：{{ item.unit }}</text>
                        </view>
                        <view class="price-action-row">
                            <view class="price-box">
                                <text class="symbol">¥</text>
                                <text class="int">{{ getPriceParts(item.shop_purchase_price/100).int }}</text>
                                <text class="dec">.{{ getPriceParts(item.shop_purchase_price/100).dec }}</text>
                            </view>
                            <view class="stepper">
                                <view class="step-btn minus" :class="{ disabled: item.num <= 1 }"
                                    @click.stop="changeNum(item, -1)">-</view>
                                <view class="step-input">{{ item.num }}</view>
                                <view class="step-btn plus" @click.stop="changeNum(item, 1)">+</view>
                            </view>
                        </view>
                    </view>
                </view>
            </view>

            <!-- 失效商品部分 -->
            <view class="invalid-section" v-if="invalidList.length > 0">
                <view class="section-header">
                    <text class="title">已失效</text>
                    <view class="clear-btn" @click="clearInvalid">
                        <img :src="comapi.getImageUrl('/wxmini/icon/icon26.png')" class="icon_del" mode="aspectFit" />
                        <text class="text">清空失效</text>
                    </view>
                </view>
                <view class="cart-card invalid-card" v-for="item in invalidList" :key="item.uuid">
                    <view class="checkbox-area">
                        <img class="check-img disabled" :src="comapi.getImageUrl('/wxmini/icon/icon25.png')"
                            mode="aspectFit" />
                    </view>
                    <view class="img-wrapper">
                        <img :src="comapi.getImageUrl(item.cover_image)" class="prod-img" mode="aspectFill" />
                        <view class="mask">
                            <text>失效</text>
                        </view>
                    </view>
                    <view class="prod-info">
                        <view class="prod-title-spec">
                            <text class="prod-title">{{ item.product_name + '（' + item.spec_name + '）' }}</text>
                            <text class="prod-spec">规格：{{ item.unit }}</text>
                        </view>
                        <view class="price-action-row">
                            <view class="price-box disabled-price">
                                <text class="symbol">¥</text>
                                <text class="int">{{ getPriceParts(item.shop_purchase_price/100).int }}</text>
                                <text class="dec">.{{ getPriceParts(item.shop_purchase_price/100).dec }}</text>
                            </view>
                            <view class="stepper disabled-stepper">
                                <view class="step-btn">-</view>
                                <view class="step-input">{{ item.num }}</view>
                                <view class="step-btn">+</view>
                            </view>
                        </view>
                    </view>
                </view>
            </view>
            <!-- 底部留白 -->
            <div style="height: 150px;"></div>
        </view>

        <!-- 空购物车 -->
        <view class="empty-cart" v-if="cartList.length === 0 && invalidList.length === 0">
            <img :src="comapi.getImageUrl('/wxmini/img/cartnone.png')" class="icon_empty" mode="aspectFit" />
            <text class="text">购物车暂无商品</text>
        </view>

        <!-- 底部操作栏（正常模式） -->
        <view class="settle-bar" v-if="!deleteMode">
            <view class="left-action">
                <view class="check-all" @click="toggleAll">
                    <img class="check-img"
                        :src="isAllChecked ? comapi.getImageUrl('/wxmini/icon/icon25_1.png') : comapi.getImageUrl('/wxmini/icon/icon25.png')"
                        mode="aspectFit" />
                    <text class="text">全选</text>
                </view>
                <view class="total-box">
                    <text class="total-text">合计：</text>
                    <view class="price-box">
                        <text class="symbol">¥</text>
                        <text class="int">{{ totalPrice }}</text>
                    </view>
                </view>
            </view>
            <view class="checkout-btn" @click="goCheckout">去结算</view>
        </view>

        <!-- 底部操作栏（删除模式） -->
        <view class="settle-bar" v-if="deleteMode">
            <view class="left-action">
                <view class="check-all" @click="toggleAll">
                    <img class="check-img"
                        :src="isAllChecked ? comapi.getImageUrl('/wxmini/icon/icon25_1.png') : comapi.getImageUrl('/wxmini/icon/icon25.png')"
                        mode="aspectFit" />
                    <text class="text">全选</text>
                </view>
            </view>
            <view class="delete-actions">
                <view class="complete-btn" @click="deleteMode = false">完成</view>
                <view class="delete-btn" @click="confirmDelete">删除</view>
            </view>
        </view>
    </view>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import comapi from "@/utils/api/com";
import storeapi from "@/utils/api/store";
import { useRouter } from 'vue-router'
const router = useRouter()
// 响应式数据
const cartList = ref([]);
const invalidList = ref([]);
const deleteMode = ref(false);

// 计算属性
const isAllChecked = computed(() => {
    if (cartList.value.length === 0) return false;
    return cartList.value.every(item => item.checked);
});

const totalPrice = computed(() => {
    let total = 0;
    cartList.value.forEach(item => {
        if (item.checked) {
            total += parseFloat(item.shop_purchase_price/100) * item.num;
        }
    });
    return total.toFixed(2);
});

// 生命周期
onMounted(() => {
    getCartList();
});

// 方法定义
const getCartList = () => {
    cartList.value = [];
    invalidList.value = [];
    let localCart = JSON.parse(localStorage.getItem('cart_data_list')) || [];
    if (localCart.length === 0) return;
    const sku_uuids = localCart.map(item => item.uuid);
    const data = {
        product_sku_uuids: sku_uuids
    }
    storeapi.getSkuStockAndStatus(data).then(res => {
        if (res.code == 200) {
            let sku_list = res.data;
            sku_list.forEach(sku => {
                localCart.forEach(item => {
                    if (item.uuid == sku.product_sku_uuid) {
                        // 默认给每个项添加 checked 属性
                        item.checked = false;
                        if (sku.product_status == 1) { // 正常
                            if (sku.salable_stock > item.num || sku.allow_negative_stock) {
                                cartList.value.push(item);
                            } else {
                                invalidList.value.push(item);
                            }
                        } else { // 已下架
                            invalidList.value.push(item);
                        }
                    }
                });
            });
        }
    });
};

const getPriceParts = (priceStr) => {
    let str = String(priceStr);
    let parts = str.split('.');
    return {
        int: parts[0] || '0',
        dec: parts[1] || '00'
    };
};
let pressTimer = null
const startPress = () => {
    pressTimer = setTimeout(() => {
        deleteMode.value = true
    }, 600) // 长按600ms
};

const cancelPress = () => {
    clearTimeout(pressTimer)
    pressTimer = null
};

const toggleCheck = (index) => {
    cartList.value[index].checked = !cartList.value[index].checked;
};

const toggleAll = () => {
    const status = !isAllChecked.value;
    cartList.value.forEach(item => {
        item.checked = status;
    });
};

const clearInvalid = () => {
    let localCart = JSON.parse(localStorage.getItem('cart_data_list')) || [];
    let invalidSkuUuids = invalidList.value.map(item => item.shop_purchase_product_sku_uuid);
    localCart = localCart.filter(item => !invalidSkuUuids.includes(item.shop_purchase_product_sku_uuid));
    localStorage.setItem('cart_data_list', JSON.stringify(localCart));
    invalidList.value = [];
};

const confirmDelete = () => {
    if (invalidList.value.length > 0) {
        return uni.showToast({ title: '请先清除失效商品', icon: 'none' });
    }
    const selectedItems = cartList.value.filter(item => item.checked);
    if (selectedItems.length === 0) {
        return uni.showToast({ title: '请选择商品', icon: 'none' });
    }

    let localCart = JSON.parse(localStorage.getItem('cart_data_list')) || [];
    const selectedUuids = selectedItems.map(item => item.shop_purchase_product_sku_uuid);
    localCart = localCart.filter(item => !selectedUuids.includes(item.shop_purchase_product_sku_uuid));

    localStorage.setItem('cart_data_list', JSON.stringify(localCart));
    cartList.value = cartList.value.filter(item => !item.checked);
};

const changeNum = (item, step) => {
    const newVal = item.num + step;
    if (newVal < 1) return;

    item.num = newVal;
    let localCart = JSON.parse(localStorage.getItem('cart_data_list')) || [];
    localCart.forEach(list => {
        if (list.uuid == item.uuid) {
            list.num = newVal;
        }
    });
    localStorage.setItem('cart_data_list', JSON.stringify(localCart));
};

const goCheckout = () => {
    if (parseFloat(totalPrice.value) <= 0) {
        return uni.showToast({ title: '请选择商品', icon: 'none' });
    }

    const buy_product_list = cartList.value
        .filter(item => item.checked)
        .map(item => ({
            product_uuid: item.product_uuid,
            product_sku_uuid: item.uuid,
            num: item.num,
            product_name: item.product_name,
            spec_name: item.spec_name,
            unit: item.unit,
            cover_image: item.cover_image,
            shop_purchase_price: item.shop_purchase_price || '0.00',
        }));

    localStorage.setItem('order_goods_list', JSON.stringify(buy_product_list));
    setTimeout(() => {
        router.push({
            path: '/store_confirm',
        })
    }, 500);
};
</script>

<style lang="less" scoped>
/* 375px 设计稿换算: 原rpx / 2 = px */
@page-padding: 17px;
@price-color: #9F3411;

.cart-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #F9F9F9;

    .empty-cart {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 100px;

        .icon_empty {
            width: 142px;
            height: 142px;
        }

        .text {
            font-size: 15px;
            color: #666;
            margin-top: 10px;
            font-weight: bold;
        }
    }

    .scroll-content {
        flex: 1;
        box-sizing: border-box;
        padding: 12px @page-padding;

        .cart-card {
            background-color: #FFFFFF;
            border-radius: 10px;
            padding: 15px 10px;
            margin-bottom: 12px;
            display: flex;
            align-items: center;

            .checkbox-area {
                width: 25px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-right: 5px;

                .check-img {
                    width: 21px;
                    height: 21px;

                    &.disabled {
                        opacity: 0.5;
                    }
                }
            }

            .prod-img {
                width: 86px;
                height: 86px;
                border-radius: 6px;
                background-color: #F5F5F5;
                margin-right: 10px;
                flex-shrink: 0;
            }

            .prod-info {
                flex: 1;
                height: 86px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .prod-title-spec {
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    .prod-title {
                        margin-bottom: 5px;
                        font-size: 15px;
                        color: #333;
                        line-height: 1.4;
                        font-weight: bold;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }

                    .prod-spec {
                        font-size: 13px;
                        color: #666;
                    }
                }

                .price-action-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;

                    .price-box {
                        color: @price-color;
                        font-weight: bold;
                        display: flex;
                        align-items: baseline;

                        .symbol {
                            font-size: 15px;
                            margin-right: 1px;
                        }

                        .int {
                            font-size: 22.5px;
                            line-height: 1;
                        }

                        .dec {
                            font-size: 15px;
                        }

                        &.disabled-price {
                            color: #999;
                        }
                    }

                    .stepper {
                        display: flex;
                        align-items: center;
                        border: 1px solid #EEEEEE;
                        border-radius: 4px;

                        .step-btn {
                            width: 25px;
                            height: 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 15px;
                            color: #666;
                            background-color: #FFF;

                            &.minus {
                                border-right: 1px solid #EEE;
                            }

                            &.plus {
                                border-left: 1px solid #EEE;
                            }

                            &.disabled {
                                color: #CCC;
                            }
                        }

                        .step-input {
                            width: 35px;
                            height: 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: #333;
                        }
                    }
                }
            }
        }

        .invalid-section {
            margin-top: 20px;

            .section-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 10px;

                .title {
                    font-size: 19px;
                    color: #333;
                    font-weight: bold;
                }

                .clear-btn {
                    font-size: 13px;
                    color: #999;
                    display: flex;
                    align-items: center;

                    .icon_del {
                        width: 23px;
                        height: 23px;
                    }

                    .text {
                        color: #DCBB89;
                        font-size: 15px;
                        line-height: 23px;
                    }
                }
            }

            .invalid-card {
                background-color: rgba(255, 255, 255, 0.6);

                .img-wrapper {
                    position: relative;
                    width: 80px;
                    height: 80px;
                    margin-right: 12px;
                    flex-shrink: 0;

                    .prod-img {
                        width: 100%;
                        height: 100%;
                        margin-right: 0;
                    }

                    .mask {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.4);
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        text {
                            color: #FFF;
                            font-size: 12px;
                            border: 1px solid #FFF;
                            padding: 2px 5px;
                            border-radius: 10px;
                        }
                    }
                }

                .prod-info {
                    .prod-title {
                        color: #999;
                    }

                    .disabled-stepper {
                        background-color: #F8F8F8;

                        .step-btn,
                        .step-input {
                            background-color: #F8F8F8;
                            color: #CCC;
                        }
                    }
                }
            }
        }
    }

    .settle-bar {
        position: fixed;
        /* 假设 H5 底部导航高度为 64px 左右 */
        bottom: calc(64px + env(safe-area-inset-bottom));
        left: 0;
        width: 100%;
        height: 60px;
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 @page-padding;
        box-sizing: border-box;
        z-index: 10;
        border-top: 1px solid #F0F0F0;
        border-bottom: 1px solid #eee;

        .left-action {
            display: flex;
            align-items: center;

            .check-all {
                display: flex;
                align-items: center;

                .check-img {
                    width: 18px;
                    height: 18px;
                    margin-right: 8px;
                }

                .text {
                    font-size: 15.5px;
                    color: #333;
                    margin-right: 10px;
                    font-weight: bold;
                }
            }

            .total-box {
                margin-left: 10px;
                display: flex;
                align-items: baseline;
                font-size: 15px;

                .total-text {
                    font-size: 13px;
                    color: #666;
                }

                .price-box {
                    color: @price-color;
                    font-weight: bold;
                    margin-left: 5px;
                    display: flex;
                    align-items: baseline;

                    .symbol {
                        font-size: 15px;
                    }

                    .int {
                        font-size: 22.5px;
                    }
                }
            }
        }

        .delete-actions {
            display: flex;
            align-items: center;

            .complete-btn {
                margin-right: 15px;
                width: 100px;
                height: 38px;
                background-color: #fff;
                color: #DCBB89;
                font-size: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 2px;
                border: 1px solid #DCBB89;
            }

            .delete-btn {
                width: 100px;
                height: 38px;
                background-color: #DCBB89;
                color: #fff;
                font-size: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 2px;
                border: 1px solid #DCBB89;
            }
        }

        .checkout-btn {
            width: 100px;
            height: 38px;
            background-color: #D6B788;
            color: #FFFFFF;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
        }
    }
}
</style>